import type { GetServerSideProps, NextPage } from 'next';
import NextLink from 'next/link';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/toast';

import AddParticipantButton from '@/components/management/AddParticipantButton';
import ManagementLayout from '@/components/management/ManagementLayout';
import ParticipantsTable from '@/components/management/ParticipantsTable';
import getManagementPageProps, {
  type ManagementPageProps,
} from '@/utils/getManagementPageProps';

export const getServerSideProps: GetServerSideProps<
  ManagementPageProps
> = async (context) => ({
  props: await getManagementPageProps(context),
});

const TeilnehmerPage: NextPage<ManagementPageProps> = ({
  isAuthenticated,
  hasAccess,
  isAdmin,
}) => {
  const [recalculatingTotals, setRecalculatingTotals] = useState(false);

  return (
    <ManagementLayout
      isAuthenticated={isAuthenticated}
      hasAccess={hasAccess}
      isAdmin={isAdmin}
    >
      {isAdmin && (
        <NextLink href="/api/downloadCards">
          <Button>Laufzettel erstellen</Button>
        </NextLink>
      )}
      {isAdmin && (
        <Button
          className="ml-2"
          disabled={recalculatingTotals}
          onClick={async () => {
            setRecalculatingTotals(true);

            const response = await fetch('/api/recalculateTotals', {
              method: 'POST',
            });

            setRecalculatingTotals(false);
            if (response.ok) {
              toast({
                title: 'Beträge neu berechnet!',
                status: 'success',
              });
            } else {
              toast({
                title: 'Fehler beim erneuten Berechnen der Beträge!',
                status: 'error',
              });
            }
          }}
        >
          {recalculatingTotals ? 'Wird berechnet...' : 'Beträge neu errechnen'}
        </Button>
      )}
      <AddParticipantButton className="ml-2" />
      <Button
        className="ml-2"
        onClick={async () => {
          const target = prompt('Startnummer des korrekten Teilnehmer:');
          const source = prompt('Startnummer des doppelten Teilnehmer:');

          if (!target || !source) {
            return;
          }

          const response = await fetch('/api/mergeParticipants', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ target, source }),
          });

          if (response.ok) {
            toast({
              title:
                'Teilnehmer zusammengeführt! Bitte laden Sie die Seite neu, um die Änderungen zu sehen',
              status: 'success',
            });
          } else {
            toast({
              title:
                'Fehler beim Zusammenführen! Existieren beide Startnummern?',
              status: 'error',
            });
          }
        }}
      >
        Teilnehmer zusammenführen
      </Button>
      <div className="overflow-x-auto">
        <ParticipantsTable isAdmin={isAdmin} />
      </div>
    </ManagementLayout>
  );
};

export default TeilnehmerPage;
